export default import.meta.ROLLDOWN_FILE_URL_fB0sydq9LzIdCrzm1PcO1Q